import { useMemo } from "react";
import { useTranslation } from "react-i18next"
import { useSchemaI18NInstance } from "./SchemaI18NProvider";


export const useSchemaTranslation = () => {
    const instance = useSchemaI18NInstance();
    const { t, i18n } = useTranslation(undefined, { i18n: instance });
    const translate = (key?: string) => key ? t("schema:::" + key, { lng: i18n.language, }) : "";
    return useMemo(() => ({ t: translate }), [t, i18n.language])
}